app.service('authorListView', function(articleAdvice, ajaxPage){

	const $self = $('#authors-page');
	function ajaxRefresh() {
		$('a.author-page-link', $self).on('click', function(event){
			event.preventDefault();
			ajaxPage.load({
				url: $(this).attr('href'),
				beforeLoad: function(){
					$.scrollTo($(0));
				}
			});
		});
	}

	function init(){
		articleAdvice.init();
		ajaxRefresh();
	}
	return{
		init
	};
});
